import { createAsyncThunk } from '@reduxjs/toolkit'

import lineRequest from 'src/api/requests/line'
import userRequest from 'src/api/requests/user'
import liffService from 'src/services/liff'
import uiActions from 'src/store/ui/notification'
import { LINE_STATUS } from 'src/constants/user'
import appActions from '../store/ui/app'

export const linkLineByLiff = createAsyncThunk<any, void>(
  'link-line-liff',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const idToken = liffService.getIDToken()
      if (!idToken) throw new Error('LINEのIDトークンが取得できませんでした。')

      const res = await lineRequest.linkLineByLiff({ id_token: idToken })
      const lineStatus = res.data?.line_status
      const resUserInfo = await userRequest.userInfo({
        with: 'userTreatments,userTreatments.reservations',
      })
      dispatch(appActions.updateAuthInfo(resUserInfo.data))

      if (lineStatus === LINE_STATUS.LINKED_AND_FOLLOWED) {
        dispatch(
          uiActions.onNotification({
            type: 'success',
            message: 'LINE連携が完了しました。',
          }),
        )
      }

      return res.data
    } catch (err: any) {
      const errorLineStatus =
        err.response?.data?.line_status ?? err.response?.data?.status

      if (errorLineStatus === LINE_STATUS.LINKED_NOT_FOLLOWED) {
        return rejectWithValue({
          ...err.response?.data,
          line_status: LINE_STATUS.LINKED_NOT_FOLLOWED,
        })
      }

      if (err.response?.status === 404) {
        dispatch(
          uiActions.onNotification({
            type: 'info',
            message: '公式アカウントを友だち追加してください。',
          }),
        )
        return rejectWithValue(err.response?.data)
      } else {
        dispatch(
          uiActions.onNotification({
            type: 'error',
            message: err.response?.data?.message || 'LINE連携に失敗しました。',
          }),
        )
        return rejectWithValue(err.response?.data)
      }
    }
  },
)

export const unlinkLine = createAsyncThunk<any, void>(
  'unlink-line',
  async (_, { dispatch }) => {
    try {
      await lineRequest.unlinkLine()
      const resUserInfo = await userRequest.userInfo({
        with: 'reservations,card,stateTransitions,cycleOrderPaid,latestOrderCanPay,orderPaymented,userTreatments,userTreatments.reservations',
      })
      dispatch(appActions.updateAuthInfo(resUserInfo.data))
      dispatch(
        uiActions.onNotification({
          type: 'success',
          message: 'LINE連携を解除しました。',
        }),
      )
    } catch (err: any) {
      dispatch(
        uiActions.onNotification({
          type: 'error',
          message:
            err.response?.data?.message || 'LINE連携の解除に失敗しました。',
        }),
      )
    }
  },
)
